/**
 * AI Validation orchestration (Dizzaroo Style Guide + Gemini semantic checks).
 * Pattern mirrors exportValidation.js / Sync & Validate menu flow.
 */

import { enrichValidationResult, normalizeValidationErrors } from '../constants/validationCheckCatalog';
import { runDeterministicAiValidationRules } from './aiValidationRules';
import validationService from '../services/validation.service';

const toDialogResult = (check) => {
  const base = {
    id: check.id,
    label: check.category ? `${check.label} (${check.category})` : check.label,
    passed: Boolean(check.passed),
    skipped: Boolean(check.skipped),
    errors: normalizeValidationErrors(check.errors),
    methodology: check.methodology || 'rule',
    howChecked: check.howChecked,
    passCriteria: check.passCriteria,
    successDetail: check.successDetail,
  };
  return enrichValidationResult(base);
};

/**
 * Run all AI validation checks: local rules + optional server Gemini/KG pass.
 * @returns {Promise<Array<{id, label, passed, errors, methodology?}>>}
 */
export const runAllAiValidations = async (
  sections = [],
  { projectId = null, studyId = null } = {}
) => {
  const results = runDeterministicAiValidationRules(sections).map(toDialogResult);

  try {
    const semantic = await validationService.runAiValidations({
      sections,
      projectId,
      studyId,
    });

    const remoteChecks = semantic?.data?.checks || semantic?.checks || [];
    remoteChecks.forEach((check) => {
      results.push(toDialogResult(check));
    });
  } catch (err) {
    console.warn('AI semantic validation unavailable:', err.message);
    results.push({
      id: 'ai-semantic-batch',
      label: 'AI Semantic Checks (Gemini / Knowledge Graph)',
      passed: false,
      errors: [
        err.message ||
          'Semantic AI validation could not run. Rule-based checks above are still valid.',
      ],
      methodology: 'ai',
    });
  }

  return results;
};

export { enrichValidationResult } from '../constants/validationCheckCatalog';
export { generateValidationReportPdf } from './validationReportPdf';

export default {
  runAllAiValidations,
};
